import React from 'react'
import Slider from 'react-toolbox/lib/slider'

import theme from './Slider.scss'

const FulcrumSlider = (props) => {
  let {
    min,
    max,
    value,
    onChange,
    editable,
    disabled,
    step
  } = props

  return (
    <Slider
      disabled={disabled}
      editable={editable}
      theme={theme}
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      step={step ? step : 0.01}
    />
  )
}

export default FulcrumSlider
